const sizes = {
  mobile: {
    WIDTH: 900,
    // HEIGHT: 600,
  },
};

export default sizes;
